import {flow, getEnv, types} from "mobx-state-tree";
import {toastr} from "react-redux-toastr";
import Notification from "../../../utils/Notification";

const DeleteMediaFileState = types.model('DeleteMediaFileState', {
    formHasErrors: types.optional(types.boolean, false),
    errorMessage: types.optional(types.string, ""),
    title: types.maybe(types.string),
    uuid: types.maybe(types.string)
})
   .volatile(self => ({
     toggleModal: types.fn,
     refreshList: types.fn,
  }))
  .actions((self) => ({
     handleHasDeleteErrors(boolean) {
        self.formHasErrors = boolean
    },
     handleDeleteErrorMessage(message) {
        self.errorMessage = message
    },
     setToggleListener(listener) {
        self.toggleModal = listener
    },
     setRefreshListener(listener) {
        self.refreshList = listener
    },

    deleteMediaFile: flow(function* () {

        const manager = getEnv(self).mediaFileManager;
        const resp = yield manager.delete(self)
        !self.formHasErrors && new Notification()
          .setType("success")
          .setMessage(`${self.title}`)
          .send();
      self.refreshList()
        !self.formHasErrors && self.toggleModal()
    }),

 }))

export default DeleteMediaFileState;
